import React from "react";

// a KYC document is a PDF or an image: images show as a thumbnail, PDFs as a link that opens the file
export const isPdfFile = (fileOrUrl) =>
  typeof fileOrUrl === "string"
    ? /\.pdf($|\?)/i.test(fileOrUrl)
    : fileOrUrl?.type === "application/pdf" || /\.pdf$/i.test(fileOrUrl?.name || "");

const KycDocPreview = ({ url, pdf }) => {
  if (!url) return null;
  if (pdf)
    return (
      <a href={url} target="_blank" rel="noreferrer" style={{ display: "block", padding: "28px 12px", textAlign: "center", fontWeight: 600 }}>
        📄 View PDF
      </a>
    );
  return <img src={url} alt="" />;
};

export default KycDocPreview;
